import { useState } from 'react';
import { Eye, X, Loader2 } from 'lucide-react';
import { Button } from '@/app/components/ui/button';
import { apiClient, clearTokens } from '@/lib/api-client';
import { getAppLoginUrl } from '@/lib/app-url';
import {
  getImpersonationState,
  clearImpersonationState,
} from '@/app/pages/platform-admin/organization-detail-page';

export function ImpersonationBanner() {
  const [state] = useState(getImpersonationState);
  const [exiting, setExiting] = useState(false);

  if (!state) return null;

  const handleExit = async () => {
    setExiting(true);
    try {
      await apiClient.post('/api/v1/auth/logout/');
    } catch {
      // Best-effort
    }
    clearTokens();
    const returnPath = state.staffReturnPath || '/platform-admin';
    clearImpersonationState();
    window.location.href = getAppLoginUrl() + '?next=' + encodeURIComponent(returnPath);
  };

  return (
    <div className="sticky top-0 z-[100] flex items-center justify-center gap-2 sm:gap-3 bg-amber-500 px-4 py-2 text-sm font-medium text-white shadow-md">
      <Eye className="h-4 w-4 shrink-0" />
      <span className="hidden sm:inline">
        Viewing as <strong>{state.targetUserName}</strong> at <strong>{state.targetOrgName}</strong>
      </span>
      <span className="sm:hidden min-w-0 truncate">
        Impersonating &middot; <strong>{state.targetUserName}</strong>
      </span>
      <Button
        variant="ghost"
        size="sm"
        className="h-7 px-2 text-white hover:bg-amber-600 hover:text-white ml-2 flex-shrink-0"
        onClick={handleExit}
        disabled={exiting}
        aria-label="Exit impersonation"
      >
        {exiting ? (
          <Loader2 className="h-3.5 w-3.5 animate-spin sm:mr-1" />
        ) : (
          <X className="h-3.5 w-3.5 sm:mr-1" />
        )}
        <span className="hidden sm:inline">{exiting ? 'Exiting...' : 'Exit Impersonation'}</span>
      </Button>
    </div>
  );
}
